// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detailed-table .text-red[data-v-637b2ca0] {\n  color: #f56c6c !important;\n  margin: 0 5px;\n}\n.el-link[data-v-637b2ca0] {\n  margin: 0 10px;\n}\n", ""]);
// Exports
module.exports = exports;
